export enum PolicyPropertyOption {
	PolicyHolder = 'Policy Holder',
	PolicyNumber = 'Policy #',
	Carrier = 'Carrier',
	PolicyOwner = 'Policy Owner',
	ServicingRole1User = 'Policy CSR',
	ServicingRole2User = 'Policy Producer',
}
